<section class="row jc-sb">
    <div class="column jc-sb pos-rel text-technologies">
        <jsdaddy-header-title black title="Technologies" subtitle="All major languages" needStar />
        <div *ngTemplateOutlet="button; context: { $implicit: 'hide-tablet hide-mobile' }"></div>
    </div>

    <div class="plus"></div>
    <jsdaddy-grid class="grid-plus" hideDesktop hideTablet />
    <div class="mustache mustache-not-mobile hide-mobile"></div>

    <img
        [ngSrc]="'mustache' | asset: 'content/home/technologies'"
        class="mustache-mobile hide-desktop hide-tablet"
        width="544"
        height="223"
        alt="mustache" />
    <div class="row right-side">
        @for (technology of technologies; track technology; let last = $last) {
            @if (technology) {
                <div class="technology no-cursor">
                    @if (!last) {
                        <img
                            width="68"
                            height="68"
                            [ngSrc]="technology | asset: 'shared/technologies'"
                            [alt]="technology" />
                    }
                </div>
            }
            @if (last) {
                <a class="technology column jc-sb no-animation" [routerLink]="contactUsPath">
                    <p class="title uppercase ls-25">
                        And<br />
                        others...
                    </p>
                    <span [attr.aria-label]="'Contact us' | anchorLabel" class="uppercase h3-text"
                        >Want to discover all?</span
                    >
                    <jsdaddy-border-button title="Let's talk" />
                </a>
            }
        }
    </div>
    <ng-container *ngTemplateOutlet="button; context: { $implicit: 'hide-desktop' }" />
</section>

<ng-template #button let-class>
    <div [ngClass]="['row ai-c become-a-client', class]">
        <div class="arrow"></div>
        <jsdaddy-button [link]="contactUsPath" type="ghost" title="Become a Client!" />
    </div>
</ng-template>
